/* IG_ENGRAVE_CRO_2026_10_11 (Shahar approved) — photo-engraving pendants only (loaded by snippets/ig-engrave.liquid).
   1) Easify option data patch, runs as a DEFER script = before Easify's module script reads window.TPOConfigs:
      front photo optional, short titles, long help texts removed, front photo first in its set. In-memory only.
   2) Theme-side UI: shared tip + "send later" note, how-it-works strip + WhatsApp help card under the ATC, one-time nudge,
      gold: «ללא שרשרת», +₪ on variant chips, pendant price line in the drawer.
   3) No photo at add-to-cart -> line property so the order shows the photo will be sent later.
   Never blocks or replaces the add-to-cart; every part is wrapped in try/catch. */
(function () {
  var C = window.IGEG || {};
  var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var WA = '972552705989', MAIL = 'info@israelgifts.co.il';
  var T = en ? {
    front: 'Front photo', back: function (p) { return 'Back photo · +₪' + p; }, text: function () { return 'Back engraving text · ₪50 per word'; },
    tip: 'Tip: a clear photo of the face and shoulders, in good light, no filters · JPG / PNG',
    later: 'Best to upload now. You can also send the photo after ordering via ',
    wa: 'WhatsApp 055-2705989', or: ' or ', dot: '.',
    propK: 'Photo', propV: 'Will be sent via WhatsApp/email after ordering',
    steps: ['Choose a pendant', 'Send a photo', 'Free mockup for your approval', C.casting ? 'Ships 10–14 business days after approval' : 'Ships 1–2 business days after approval'],
    cert: 'Includes a gold certificate',
    helpB: 'Need help choosing a photo or with the engraving?', helpS: 'We\'re on WhatsApp – quick replies', helpBtn: 'WhatsApp',
    nudge: 'Not sure which photo will engrave best? ', nudgeL: 'Send it to us on WhatsApp – we\'ll check for free', close: 'Close',
    waMsg: 'Hi, I\'d like help with a photo / engraving for: ', noChain: 'chain not included', pend: 'Pendant price: '
  } : {
    front: 'תמונה לצד קדמי', back: function (p) { return 'תמונה לצד אחורי · +' + p + ' ₪'; }, text: function () { return 'טקסט לחריטה בגב · 50 ₪ למילה'; },
    tip: 'טיפ: תמונה ברורה של פנים וכתפיים, באור טוב ובלי פילטרים · JPG / PNG',
    later: 'מומלץ להעלות תמונה כבר עכשיו. אפשר גם לשלוח את התמונה אחרי ביצוע ההזמנה ב', wa: 'וואטסאפ 055-2705989', or: ' או ', dot: '',
    propK: 'תמונה', propV: 'תישלח בוואטסאפ/מייל לאחר ההזמנה',
    steps: ['בוחרים תליון', 'שולחים תמונה', 'הדמיה לאישורכם, בחינם', C.casting ? 'נשלח תוך 10–14 ימי עסקים מהאישור' : 'נשלח תוך 1–2 ימי עסקים מהאישור'],
    cert: 'כולל תעודת זהב',
    helpB: 'זקוקים לעזרה בבחירת תמונה או בחריטה?', helpS: 'אנחנו כאן בוואטסאפ – עונים מהר', helpBtn: 'לוואטסאפ',
    nudge: 'מתלבטים איזו תמונה תיחרט הכי יפה? ', nudgeL: 'שלחו לנו בוואטסאפ ונבדוק בחינם', close: 'סגירה',
    waMsg: 'שלום, אשמח לעזרה בבחירת תמונה/חריטה עבור: ', noChain: 'ללא שרשרת', pend: 'מחיר התליון: '
  };

  // ---------- 1) Easify data patch (must run before Easify's module script) ----------
  var WORDS = /מספר מילים לחריטה|Words to engrave/i, NONE = en ? 'No text' : 'ללא טקסט', CAPW = 10, AVAILW = 0;
  function maxW() { return Math.min(CAPW, AVAILW || 7); }   // only as many words as the Easify dropdown can actually charge
  var FRONT = /חריטה בקדמת|engraving on the front/i, BACK = /חריטה בגב|engraving on the back/i, TEXT = /טקסט לחריטה בגב|Text for engraving on the back/i;
  if (/per word|למילה/.test(T.text())) TEXT = /טקסט לחריטה בגב|Text for engraving on the back|Back engraving text/i;
  try {
    var sets = (window.TPOConfigs && window.TPOConfigs.option_sets_searchable) || [];
    sets.forEach(function (s) {
      var d = s && s.data; if (!d || !d.options || !d.options.forEach) return;
      var hasFront = false;
      d.options.forEach(function (o) {
        var t = String(o.title || '');
        if (o.type === 'file-upload' && FRONT.test(t)) { o.is_required = 0; o.title = T.front; o.help_text = ''; o.info_text = ''; o.sort_order = -10; hasFront = true; }
        else if (o.type === 'file-upload' && BACK.test(t)) { o.title = T.back(+o.additional_price || 500); o.help_text = ''; o.info_text = ''; o.sort_order = -9; }
        else if (o.type === 'text-box' && TEXT.test(t)) {
          o.title = T.text(); o.help_text = ''; o.info_text = '';
          // IG_WORDS_2026_10_11: the text itself is free (old ₪15/letter add-on variant must never be attached); words are charged by the dropdown
          o.price_type = 'one'; o.additional_price = 0; o.option_types = [];
          o.placeholder = en ? 'Up to 10 words (optional)' : 'עד 10 מילים (לא חובה)';
        }
        else if (o.type === 'dropdown' && WORDS.test(t) && o.option_types && o.option_types.unshift && !o.__igeg) {
          o.__igeg = 1; o.is_required = 0;
          AVAILW = Math.max(AVAILW, o.option_types.length);
          var f0 = o.option_types[0] || {};
          o.option_types.unshift({ option_type_id: 0, label: NONE, sort_order: -1, option_id: o.option_id, is_default: 0, image_url: '', number_color: 1, color_code: ',', additional_price: 0, image_id: 'default_id_image', id: 'igeg-none-' + o.option_id, product_id: '', variant_id: '', product_handle: '', metadata: '{"disabled":null}', product_name: '', is_created: 0, use_price: 0, image_canvas_url: '' });
        }
      });
      if (hasFront && d.options.sort) d.options.sort(function (a, b) { return (+a.sort_order || 0) - (+b.sort_order || 0); });
    });
    window.__igegPatched = 1;
  } catch (e) { window.__igegPatched = 'err'; }

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function title() { var h = document.querySelector('.product-info h1, h1'); return ((h && h.textContent) || C.title || '').trim(); }
  function waHref() { return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(T.waMsg + title() + ' ' + location.origin + decodeURI(location.pathname)); }
  // WhatsApp opener that the floating-WhatsApp app can't restyle (it targets a[href*="wa.me"])
  function waLink(cls, text) { return '<span class="' + cls + '" role="link" tabindex="0" data-igeg-wa>' + esc(text) + '</span>'; }
  document.addEventListener('click', function (e) { var w = e.target.closest && e.target.closest('[data-igeg-wa]'); if (!w) return; e.preventDefault(); window.open(waHref(), '_blank', 'noopener'); }, true);
  document.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('[data-igeg-wa]')) { e.preventDefault(); window.open(waHref(), '_blank', 'noopener'); } });
  var WAICO = '<svg width="18" height="18" viewBox="0 0 24 24" fill="#fff" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .2-3.3-.7-2.8-1.1-4.6-4-4.7-4.2-.1-.2-1.1-1.5-1.1-2.9s.7-2.1 1-2.4c.3-.3.6-.3.8-.3h.6c.2 0 .4 0 .6.5l.9 2.1c.1.2.1.4 0 .5l-.3.5-.4.4c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.3 2.4 1.5.3.1.5.1.6-.1l.9-1.1c.2-.3.4-.2.7-.1l2 1c.3.1.5.2.5.3.1.2.1.7-.1 1.3z"/></svg>';

  // ---------- 2a) Easify upload boxes: tag + shared note ----------
  function noteHtml() {
    return '<div class="igeg-tip">' + esc(T.tip) + '</div><div class="igeg-later">' + esc(T.later) + waLink('igeg-lnk', T.wa) + esc(T.or) +
      '<a class="igeg-lnk" href="mailto:' + MAIL + '">' + (en ? 'email ' : 'במייל ') + MAIL + '</a>' + esc(T.dot) + '</div>';
  }
  function hasPhoto(scope) {
    var r = (scope || document).querySelectorAll('.igeg-front');
    for (var i = 0; i < r.length; i++) {
      var h = r[i].querySelectorAll('input[type="hidden"][name^="properties["]');
      for (var j = 0; j < h.length; j++) if (String(h[j].value || '').trim()) return true;
      if (r[i].querySelector('.po-fileUpload-uploadItem')) return true;
    }
    return false;
  }
  function tagEasify() {
    var roots = document.querySelectorAll('.easify .po-option-root');
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i], lab = r.querySelector('.po-label-labelContent'), lt = lab ? lab.textContent.trim() : '';
      if (r.querySelector('input[type="file"]')) {
        var front = lt === T.front || FRONT.test(lt), back = !front && (lt.indexOf(en ? 'Back photo' : 'תמונה לצד אחורי') === 0 || BACK.test(lt));
        if (!front && !back) continue;
        r.classList.add('igeg-file', front ? 'igeg-front' : 'igeg-back');
      } else if (r.querySelector('.po-select-button') && lab && WORDS.test(lt)) {
        r.classList.add('igeg-words'); r.setAttribute('aria-hidden', 'true');
      } else if (r.querySelector('input[type="text"], textarea') && (TEXT.test(lt) || lt.indexOf(en ? 'Back engraving text' : 'טקסט לחריטה בגב') === 0)) {
        r.classList.add('igeg-text');
        var inp = r.querySelector('input[type="text"], textarea'); if (inp && inp.getAttribute('placeholder') !== (en ? 'Up to 10 words (optional)' : 'עד 10 מילים (לא חובה)')) inp.setAttribute('placeholder', en ? 'Up to 10 words (optional)' : 'עד 10 מילים (לא חובה)');
      }
    }
    var set = document.querySelectorAll('.easify .po-options-root');
    for (var k = 0; k < set.length; k++) {
      var fr = set[k].querySelector(':scope > .igeg-front'); if (!fr) continue;
      var bk = set[k].querySelector(':scope > .igeg-back'), anchor = bk || fr;
      var n = set[k].querySelector(':scope > .igeg-note');
      if (!n) { n = el('div', 'igeg-note', noteHtml()); n.setAttribute('dir', en ? 'ltr' : 'rtl'); }
      if (anchor.nextSibling !== n) set[k].insertBefore(n, anchor.nextSibling);
    }
  }

  // ---------- 3) No photo -> line property (decided at the moment of the add-to-cart click / submit) ----------
  function syncProp(form) {
    try {
      if (!form || !document.querySelector('.igeg-front')) return;
      var name = 'properties[' + T.propK + ']', inp = form.querySelector('input[data-igeg-prop]');
      if (hasPhoto(form.closest('.pdpd-sheet') || document)) { if (inp) inp.parentNode.removeChild(inp); return; }
      if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.setAttribute('data-igeg-prop', ''); form.appendChild(inp); }
      inp.name = name; inp.value = T.propV;
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[type="submit"], [data-ig-atc-proxy]'); if (!b) return;
    var f = b.form || (b.closest && b.closest('form'));
    if (!f && b.hasAttribute('data-ig-atc-proxy')) { var bar = document.querySelector('.pdpd-stickybar'); var id = bar && bar.getAttribute('data-ig-form'); f = id && document.getElementById(id); }
    if (f && /\/cart\/add/.test(f.getAttribute('action') || '')) syncProp(f);
  }, true);
  document.addEventListener('submit', function (e) { var f = e.target; if (f && /\/cart\/add/.test(f.getAttribute('action') || '')) syncProp(f); }, true);

  // ---------- 2b) strip + help card under the add-to-cart ----------
  function stripHtml() {
    var s = '<ol class="igeg-steps">';
    T.steps.forEach(function (t, i) { s += '<li><span class="igeg-n">' + (i + 1) + '</span><span class="igeg-st">' + esc(t) + '</span></li>'; });
    s += '</ol>';
    if (C.gold) s += '<div class="igeg-cert">' + esc(T.cert) + '</div>';
    return s;
  }
  function cardHtml() {
    return '<span class="igeg-card__ico">' + WAICO + '</span><span class="igeg-card__txt"><b>' + esc(T.helpB) + '</b>' + esc(T.helpS) + '</span>' + waLink('igeg-card__btn', T.helpBtn);
  }
  function atcAnchor() {
    var u = document.querySelector('[data-ig-atc-under]');
    if (u && !u.hidden && u.offsetParent !== null) return u;                       // inline products (after the drawer collapses)
    var p = document.querySelector('.pdpd-primary');
    if (p && !p.closest('.pdpd-overlay') && p.isConnected) return p;                // drawer products
    return document.querySelector('.product-info form[action$="/cart/add"] buy-buttons');
  }
  function placeUnderAtc() {
    var anchor = atcAnchor(); if (!anchor || !anchor.parentNode) return;
    var how = document.querySelector('.igeg-how'), card = document.querySelector('.igeg-card');
    if (!how) { how = el('div', 'igeg-how', stripHtml()); how.setAttribute('dir', en ? 'ltr' : 'rtl'); }
    if (!card) { card = el('div', 'igeg-card', cardHtml()); card.setAttribute('dir', en ? 'ltr' : 'rtl'); }
    // re-anchor whenever the ATC moved (pdp-drawer.js collapses the drawer to an inline buy box ~2 s after load)
    if (anchor.nextSibling !== how) anchor.parentNode.insertBefore(how, anchor.nextSibling);
    if (how.nextSibling !== card) how.parentNode.insertBefore(card, how.nextSibling);
  }

  // ---------- 2c) gold: «ללא שרשרת», +₪ on chips, pendant price in the drawer ----------
  function fmt(c) { return Math.round(c / 100).toLocaleString('he-IL') + ' ₪'; }
  function variantMap(vp) {
    var ns = vp.querySelector('noscript'); if (!ns) return null;
    var m = {}, re = /<option[^>]*value="(\d+)"[^>]*>([\s\S]*?)<\/option>/g, x, txt = ns.textContent || ns.innerHTML;
    while ((x = re.exec(txt))) {
      var t = x[2].replace(/<[^>]+>/g, '').replace(/&quot;/g, '"').replace(/&amp;/g, '&').trim();
      var i = t.lastIndexOf(' - '); if (i < 0) continue;
      var p = t.slice(i + 3).replace(/[^\d.]/g, ''); if (!p) continue;
      m[t.slice(0, i).trim()] = Math.round(parseFloat(p) * 100);
    }
    return m;
  }
  function chips() {
    var vps = document.querySelectorAll('variant-picker');
    for (var v = 0; v < vps.length; v++) {
      var vp = vps[v], map = variantMap(vp); if (!map) continue;
      var fs = vp.querySelectorAll('fieldset.variant-picker__option');
      var cur = [];
      for (var i = 0; i < fs.length; i++) { var c = fs[i].querySelector('input[type="radio"]:checked'); var l = c && vp.querySelector('label[for="' + c.id + '"] span'); cur.push(l ? l.textContent.trim() : ''); }
      var base = map[cur.join(' / ')]; if (base == null) continue;
      for (var j = 0; j < fs.length; j++) {
        var labs = fs[j].querySelectorAll('label.block-swatch, label');
        for (var k = 0; k < labs.length; k++) {
          var sp = labs[k].querySelector('span:not(.igeg-delta)'); if (!sp) continue;
          var alt = cur.slice(); alt[j] = sp.textContent.trim();
          var p = map[alt.join(' / ')], d = labs[k].querySelector('.igeg-delta'), txt = (p != null && p > base) ? '+' + fmt(p - base) : '';
          if (!txt) { if (d) d.parentNode.removeChild(d); continue; }
          if (!d) { d = el('small', 'igeg-delta'); labs[k].appendChild(d); }
          if (d.textContent !== txt) d.textContent = txt;
        }
      }
      var sheet = vp.closest('.pdpd-sheet');
      if (sheet) {
        var bb = sheet.querySelector('buy-buttons');
        if (bb && bb.parentNode) {
          var pl = sheet.querySelector('.igeg-dprice');
          if (!pl) { pl = el('div', 'igeg-dprice'); bb.parentNode.insertBefore(pl, bb); }
          var t2 = T.pend + fmt(base) + (C.chain ? ' · ' + T.noChain : '');
          if (pl.textContent !== t2) pl.textContent = t2;
        }
      }
    }
  }
  function noChain() {
    if (!C.chain) return;
    var pls = document.querySelectorAll('.product-info [data-block-type="price"] price-list');
    for (var i = 0; i < pls.length; i++) {
      var n = pls[i].nextElementSibling;
      if (n && n.classList.contains('igeg-nochain')) continue;
      var s = el('span', 'igeg-nochain'); s.textContent = T.noChain;
      pls[i].parentNode.insertBefore(s, pls[i].nextSibling);
    }
  }

  // ---------- 2d) one-time nudge ----------
  function nudge() {
    try {
      if (sessionStorage.getItem('igegNudge') || hasPhoto()) return;
      var o = document.querySelector('.pdpd-overlay.is-open'); if (o) return;
      sessionStorage.setItem('igegNudge', '1');
      var n = el('div', 'igeg-nudge', '<button type="button" class="igeg-nudge__x" aria-label="' + T.close + '">✕</button><span class="igeg-card__ico">' + WAICO + '</span><span class="igeg-nudge__t">' + esc(T.nudge) + waLink('igeg-nudge__l', T.nudgeL) + '</span>');
      n.setAttribute('dir', en ? 'ltr' : 'rtl'); n.setAttribute('role', 'status');
      n.querySelector('button').addEventListener('click', function () { n.parentNode && n.parentNode.removeChild(n); });
      document.body.appendChild(n);
    } catch (e) {}
  }
  function armNudge() {
    try { if (sessionStorage.getItem('igegNudge')) return; } catch (e) { return; }
    if (window.matchMedia('(min-width: 990px) and (hover: hover)').matches) {
      var h = function (e) { if (!e.relatedTarget && e.clientY < 12) { document.removeEventListener('mouseout', h); nudge(); } };
      setTimeout(function () { document.addEventListener('mouseout', h); }, 8000);
    } else setTimeout(nudge, 40000);
  }


  // ---------- 4) IG_WORDS_2026_10_11: ₪50 per word via the (visually hidden) Easify words dropdown ----------
  function countWords(v) { v = String(v || '').trim(); return v ? v.split(/\s+/).length : 0; }
  function wordsLabel(n) { return n === 0 ? NONE : (en ? (n === 1 ? '1 word' : n + ' words') : (n === 1 ? 'מילה אחת' : n + ' מילים')); }
  function wordsRootFor(textRoot) {
    var set = textRoot.closest('.po-options-root') || document;
    return set.querySelector('.igeg-words') || document.querySelector('.igeg-words');
  }
  function curLabel(wr) {
    var ph = wr && wr.querySelector('.po-select-placeholder'); if (!ph) return null;
    var t = Array.prototype.map.call(ph.childNodes, function (n) { return n.nodeType === 3 ? n.nodeValue : ''; }).join('').trim();
    t = t.replace(/\s*\([^()]*\)\s*$/, '').trim();   // drop Easify's " (150.00 ₪)" price suffix
    return /^(אנא בחר|Please select|בחר)/i.test(t) ? '' : t;
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  var busy = null;
  function selectWords(wr, n) {
    var want = wordsLabel(n), cur = curLabel(wr);
    if (cur === want || (n === 0 && cur === '')) return Promise.resolve(true);
    var run = function () {
      var btn = wr.querySelector('.po-select-button'); if (!btn) return Promise.resolve(false);
      if (btn.getAttribute('aria-expanded') !== 'true') btn.click();
      var tries = 0;
      return (function poll() {
        var lis = wr.querySelectorAll('li.po-select-listItem');
        if (!lis.length) lis = document.querySelectorAll('li.po-select-listItem');
        for (var i = 0; i < lis.length; i++) {
          var l = lis[i].querySelector('.po-optionItemLabel-label');
          if (l && l.textContent.trim() === want) { lis[i].click(); return wait(60).then(function () { return curLabel(wr) === want; }); }
        }
        if (++tries > 25) { if (btn.getAttribute('aria-expanded') === 'true') btn.click(); return Promise.resolve(false); }
        return wait(40).then(poll);
      })();
    };
    busy = (busy || Promise.resolve()).then(run, run);
    return busy;
  }
  function liveLine(tr, n) {
    var f = tr.querySelector('.po-field-root') || tr, ln = tr.querySelector('.igeg-wline');
    if (!ln) { ln = el('div', 'igeg-wline'); ln.setAttribute('aria-live', 'polite'); f.appendChild(ln); }
    var txt = '', mw = maxW(), over = n > mw;
    if (over) txt = en ? 'Up to ' + mw + ' words – please shorten the text' : 'עד ' + mw + ' מילים – נא לקצר את הטקסט';
    else if (n > 0) txt = wordsLabel(n) + ' · ' + (en ? '+₪' + (n * 50) : '\u200E+' + (n * 50) + ' ₪');
    ln.classList.toggle('is-over', over);
    if (ln.textContent !== txt) ln.textContent = txt;
  }
  function syncWords(tr) {
    var inp = tr && tr.querySelector('input[type="text"], textarea'); if (!inp) return Promise.resolve(true);
    var n = countWords(inp.value); liveLine(tr, n);
    var wr = wordsRootFor(tr); if (!wr) return Promise.resolve(n === 0);
    if (n > maxW()) return Promise.resolve(false);
    return selectWords(wr, n);
  }
  var wt = 0;
  document.addEventListener('input', function (e) {
    var tr = e.target && e.target.closest && e.target.closest('.igeg-text'); if (!tr) return;
    clearTimeout(wt); wt = setTimeout(function () { syncWords(tr); }, 250);
  }, true);
  function mismatch(scope) {
    var trs = (scope || document).querySelectorAll('.igeg-text');
    for (var i = 0; i < trs.length; i++) {
      var inp = trs[i].querySelector('input[type="text"], textarea'); if (!inp) continue;
      var n = countWords(inp.value), wr = wordsRootFor(trs[i]);
      if (n > maxW()) return { tr: trs[i], over: true };
      if (wr && !(curLabel(wr) === wordsLabel(n) || (n === 0 && curLabel(wr) === ''))) return { tr: trs[i] };
    }
    return null;
  }
  // at add-to-cart: if the words dropdown doesn't match the text, hold the click, fix it, then click again
  var reclick = false;
  document.addEventListener('click', function (e) {
    if (reclick) return;
    var b = e.target.closest && e.target.closest('button[type="submit"]'); if (!b) return;
    var f = b.form || b.closest('form'); if (!f || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    var scope = b.closest('.pdpd-sheet') || document, m = mismatch(scope); if (!m) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (m.over) { liveLine(m.tr, maxW() + 1); try { m.tr.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (x) {} return; }
    syncWords(m.tr).then(function (ok) {
      // fail-open: never hold a purchase because of the sync (only the over-limit case above blocks)
      setTimeout(function () { reclick = true; try { b.click(); } finally { reclick = false; } }, 120);
    });
  }, true);

  // ---------- boot ----------
  var t = 0;
  function run() { try { tagEasify(); } catch (e) {} try { chips(); noChain(); } catch (e) {} try { placeUnderAtc(); } catch (e) {} }
  function boot() {
    run(); armNudge();
    if ('MutationObserver' in window) new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 80); }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function () { setTimeout(run, 60); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
